import React from 'react';
import { Grid, Header, Icon, Label } from 'semantic-ui-react';

import Campo from './Campo';
import CampoDireccion from './VistaDireccion';
// Aun faltan todas las cosas que van después del "ver mas"

interface Direccion {
    region: {
        codigo: string;
        nombre: string;
    };
    comuna: {
        codigo: string;
        nombre: string;
    };
    calle: string;
    numero: string;
    dpto?: string;
    block?: string;
    poblacion?: string;
}

interface Direcciones {
    particular: Direccion;
    laboral: Direccion;
}

interface InformacionApoderadoProps {
    nombreCompletoApoderado: string;
    rutPasaporte: string;
    correo: string[];
    telefonos: Array<{ nombre: string; codArea: string; numero: string; whatsApp: boolean }>;
    direcciones: Direcciones;
}

interface State {
    mostrarMas: boolean;
}

class InformacionApoderado extends React.Component<InformacionApoderadoProps, State> {
    public state: State = {
        mostrarMas: false,
    };

    public render() {
        const {
            nombreCompletoApoderado,
            rutPasaporte,
            correo,
            telefonos,
            direcciones,
        } = this.props;

        const { mostrarMas } = this.state;

        return (
            <div>
                <Header as='h1'>{nombreCompletoApoderado}</Header>

                <Grid columns={2}>
                    <Grid.Row>
                        <Grid.Column>
                            <Campo etiqueta='Rut/Pasaporte' valor={rutPasaporte} />
                            {correo.map((correos, indice) => (
                                <Campo
                                    key={indice}
                                    etiqueta={
                                        'Correo electrónico' +
                                        (correos.length > 1 ? ` ${indice + 1}` : '')
                                    }
                                    valor={correos}
                                />
                            ))}
                        </Grid.Column>
                        <Grid.Column>
                            {telefonos.map(({ nombre, codArea, numero }) =>
                                numero.length > 0 ? (
                                    <Campo
                                        key={nombre}
                                        etiqueta={'Teléfono ' + nombre}
                                        valor={`+56${codArea} ${numero}`}
                                    />
                                ) : (
                                    false
                                ),
                            )}
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column />
                        <Grid.Column>
                            <Label
                                as='a'
                                basic
                                onClick={() => {
                                    this.setState({ mostrarMas: !mostrarMas });
                                }}
                            >
                                <Icon
                                    name='dropdown'
                                    rotated={mostrarMas ? undefined : 'counterclockwise'}
                                />
                                {mostrarMas ? 'Mostrar menos' : 'Mostrar más'}
                            </Label>
                        </Grid.Column>
                    </Grid.Row>

                    {mostrarMas && (
                        <Grid.Row>
                            <Grid.Column>
                                <CampoDireccion
                                    titulo='Dirección particular'
                                    direccion={direcciones.particular}
                                />
                            </Grid.Column>

                            <Grid.Column>
                                <CampoDireccion
                                    titulo='Dirección laboral'
                                    direccion={direcciones.laboral}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    )}
                </Grid>
            </div>
        );
    }
}

export default InformacionApoderado;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/FichaDeApoderado/InformacionApoderado.tsx